// TODO - Type 'any' needs to be fixed.
import { useMemo } from "react";
import { useSelector } from "react-redux";

import useWorkersData from "../../../../../../controllers/use-workers-data";
import {WorkerCert} from "../../../../../../types"


interface FormikInitialValuesProps {
    levelId: any;
    skillId: any;
    validFrom: any;
    validTo: any;
    skillName: string;
}

const getCertificationsBySkillId = (data: WorkerCert[], skillId: number): WorkerCert[] => {
	const result: WorkerCert[] = [];

	try {
		if (!data) return result;

		data.forEach(workerCert => {
			try {
				if (!workerCert || !workerCert.skillIds) return;

				const skillIds = workerCert.skillIds.split(",").map(id => parseInt(id.trim(), 10));

				if (skillIds.includes(skillId)) {
					result.push(workerCert);
				}
			} catch (innerError) {
				console.log("Error processing workerCert:", innerError);
			}
		});
	} catch (error) {
		console.log("Error processing data:", error);
	}

	return result;
};

const useEditSkillDialogController = () => {
	const initialValues = useSelector(
		(state: any) => state.manageWorkers.editWorkerSkillDialog.skillData
	);
	const {
		allSkillLevels,
		enableSkillEvaluationForm,
		workerId,
		pendingSkillEvaluationSkillIds,
    workerProfile,
	} = useWorkersData();
	const workerCerts = useSelector(
		(state: any) => state.manageWorkers.workerProfile.profile.workerCerts
	);
	const requiredCertifications = useMemo<WorkerCert[]>(() => {
		if (!initialValues || !workerCerts) return [];
		return getCertificationsBySkillId(workerCerts, initialValues.skillId);
	}, [initialValues, workerCerts]);

	const formikInitialValues = useMemo<FormikInitialValuesProps>(() => {
		if (!initialValues) {
			return {
				levelId: null,
				skillId: null,
				validFrom: null,
				validTo: null,
				skillName: "",
			};
		}
		return {
			...initialValues,
			validFrom: initialValues.validFrom ? initialValues.validFrom.split("T")[0] : null,
			validTo: initialValues.validTo ? initialValues.validTo.split("T")[0] : null,
		};
	}, [initialValues]);

	return {
		formikInitialValues,
		requiredCertifications,
		allSkillLevels,
		enableSkillEvaluationForm,
		workerId,
		workerProfile,
		pendingSkillEvaluationSkillIds,
	};
};

export default useEditSkillDialogController;
